/*
 * Jira Ticket:
 * Created Date: Thu, 9th Apr 2020, 12:19:42 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const getManyProjectQuery = gql`
  query allProjects(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: ProjectFilter
  ) {
    items: allProjects(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      name
    }
    total: _allProjectsMeta(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      count
    }
  }
`;
